import { AxiosError } from "axios";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { Skill, SkillCreate } from "@/model";
import skillRepository from "@/repository/skillRepository";
import { skillQueryKeys } from "./keys";


export const useCreateSkill = (agentId: number) => {
    const queryClient = useQueryClient();

    return useMutation<Skill, AxiosError, SkillCreate>({
        mutationKey: ["skill", "agent", agentId, "create"],
        mutationFn: async (body: SkillCreate) => {
            try {
                const { data } = await skillRepository.create(agentId, body);
                return data;
            } catch (e) {
                throw e;
            }
        },
        onSuccess: async () => {
            await queryClient.invalidateQueries({
                queryKey: skillQueryKeys.all(agentId)
            });
        }
    });
};
